import React from 'react';
import { useCalculator } from '../context/CalculatorContext';

const VariantSelector: React.FC = () => {
  const { formState, setFormState } = useCalculator();
  const { variants } = formState;
  
  const handleChange = (newVariants: number) => {
    setFormState({...formState, variants: newVariants});
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-2">
        Number of Variants
      </label>
      <div className="grid grid-cols-3 gap-3">
        {/* A/B Test Card */}
        <div 
          className={`cursor-pointer rounded-lg p-3 border-2 transition-all ${
            variants === 2
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' 
              : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-700'
          }`}
          onClick={() => handleChange(2)}
        >
          <h3 className="font-medium text-center">A/B</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            1 variant + control
          </p>
        </div>
        
        {/* A/B/C Test Card */}
        <div 
          className={`cursor-pointer rounded-lg p-3 border-2 transition-all ${
            variants === 3
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' 
              : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-700'
          }`}
          onClick={() => handleChange(3)}
        >
          <h3 className="font-medium text-center">A/B/C</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            2 variants + control
          </p>
        </div>
        
        {/* A/B/C/D Test Card */}
        <div 
          className={`cursor-pointer rounded-lg p-3 border-2 transition-all ${
            variants === 4
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' 
              : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-700'
          }`}
          onClick={() => handleChange(4)}
        >
          <h3 className="font-medium text-center">A/B/C/D</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            3 variants + control
          </p>
        </div>
      </div>
    </div>
  );
};

export default VariantSelector;
